import { render } from "./StoreManagers.vue?vue&type=template&id=0c95a4bc&scoped=true"
import script from "./StoreManagers.vue?vue&type=script&lang=js"
export * from "./StoreManagers.vue?vue&type=script&lang=js"

import "./StoreManagers.vue?vue&type=style&index=0&id=0c95a4bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c95a4bc"]])

export default __exports__